import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import PrimaryButton from '@components/PrimaryButton';
import { HeaderLayout } from '@layouts';
import avatar from '@assets/avatar.jpg';
import { ROUTES } from '@constants';

import accountData from './accountData';
import { useStyles, useStylesButtonSecondary } from './styles';

function AccountSettingsScreen() {
  const history = useHistory();
  const classes = useStyles();
  const classesButtonSecondary = useStylesButtonSecondary();

  const { t } = useTranslation('accountSettings');

  const goToDrinksHistoryScreen = () => {
    history.push(ROUTES.DRINKS_HISTORY_SCREEN, {
      from: ROUTES.ACCOUNT_SETTINGS_SCREEN,
    });
  };

  return (
    <HeaderLayout title={t('title')}>
      <Box className={classes.avatarContainer}>
        <img src={avatar} alt="" className={classes.avatarImg} />
        <PrimaryButton
          classesButton={classesButtonSecondary}
          text={t('changeAvatar')}
          handleClick={goToDrinksHistoryScreen}
        />
      </Box>
      <Typography className={classes.informationTitle}>
        {t('information')}
      </Typography>
      <Box>
        {Object.values(accountData).map(item => {
          return (
            <Box key={item} className={classes.informationItem}>
              {item}
            </Box>
          );
        })}
      </Box>
      <PrimaryButton
        text={t('button:drinksHistory')}
        handleClick={goToDrinksHistoryScreen}
      />
    </HeaderLayout>
  );
}

export default AccountSettingsScreen;
